const colorModeToggle = document.querySelectorAll('.dark-mode')

const checkAndSetTheme = () => {
	const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
	const isDarkTheme = localStorage.theme === 'dark' || (localStorage.theme !== 'light' && prefersDarkMode === true)

	document.documentElement.classList.toggle('dark', isDarkTheme)
	localStorage.theme = isDarkTheme ? 'dark' : 'light'
	document.body.classList.add('!block')
}

const toggleTheme = () => {
	localStorage.theme = localStorage.theme === 'dark' ? 'light' : 'dark'
	checkAndSetTheme()
}

checkAndSetTheme()
colorModeToggle.forEach(toggle => {
	toggle.addEventListener('click', toggleTheme)
})
